import React, { useState } from "react"
import { createStyles, makeStyles } from "@material-ui/core/styles"
import { Dialog, DialogContent } from "@material-ui/core"
import { useTrack } from "@hackler/react-sdk"
import usePlatform from "../../hooks/usePlatform"
import { Locale } from "../../locale"

const useStyles = makeStyles(() =>
  createStyles({
    paperWidthSm: {
      maxWidth: 826,
      width: 826,
    },
    videoPanel: {
      width: 826,
      height: 484,
      float: "left",
      "&:after": {
        clear: "both",
      },
    },
    videoContainer: {
      position: "relative",
      paddingBottom: "56.25%",
      height: 0,
      overflow: "hidden",
      "& iframe, & object, & embed": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      },
    },
    dialogContent: {
      padding: 0,
      paddingTop: "0!important",
    },
  })
)

interface Props {
  ButtonElement(handleButtonClick: () => void): React.ReactElement
}

export default function AbTestVideoDialog({ ButtonElement }: Props) {
  const classes = useStyles()
  const [opened, setOpened] = useState(false)
  const { isMobile } = usePlatform()
  const track = useTrack()
  const lang = Locale.getLangCode()
  const handleCloseModal = () => {
    track({ key: "homepage_ab_test_video_modal_close_click" })
    setOpened(false)
  }
  const handleOpenModal = () => {
    track({ key: "homepage_ab_test_main_show_video_click" })
    setOpened(true)
  }
  return (
    <>
      {ButtonElement(handleOpenModal)}
      <Dialog
        open={opened}
        onClose={handleCloseModal}
        aria-labelledby="dialog-title"
        classes={{ paperWidthSm: classes.paperWidthSm }}>
        <DialogContent className={classes.dialogContent}>
          <div className={isMobile ? classes.videoContainer : classes.videoPanel}>
            <iframe
              width="826"
              height="484"
              src={
                lang === "ko"
                  ? "https://www.youtube.com/embed/nOGmjfsaTgU?mute=1&loop=1&playlist=nOGmjfsaTgU&autoplay=1"
                  : "https://www.youtube.com/embed/Oyxnr1KwFww?mute=1&loop=1&playlist=Oyxnr1KwFww&autoplay=1"
              }
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}
